export default __webpack_public_path__ + "static/media/pending_approved.893300d1.png";